var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    !!_vm.region
      ? _c(
          "div",
          [
            _c("research-region-plot", {
              attrs: {
                plotData: _vm.assocData,
                renderConfig: _vm.plotConfig,
                searchParameters: _vm.searchParameters,
                dataComparisonConfig: _vm.dataComparisonConfig,
                region: _vm.region,
                plotMargin: _vm.plotMargin,
                compareGroupColors: _vm.colors,
                regionZoom: 0,
                regionViewArea: 0,
                pkgData: [],
                pkgDataSelected: [],
                utils: _vm.utilsBox,
                sectionId: `${_vm.sectionId}_region`,
              },
              on: { plotRendered: (e) => _vm.loadPlot(e) },
            }),
            !_vm.plotLoaded
              ? _c(
                  "div",
                  [_c("b-spinner", { attrs: { label: "Loading..." } })],
                  1
                )
              : _vm._e(),
            _c("research-genes-track", {
              attrs: {
                region: _vm.region,
                plotConfig: _vm.plotConfig,
                plotType: "region plot",
                plotMargin: _vm.plotMargin,
                regionZoom: 0,
                regionViewArea: 0,
                utils: _vm.utilsBox,
                sectionId: `${_vm.sectionId}_genes`,
              },
            }),
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "loading" },
          [_c("b-spinner", { attrs: { label: "Loading..." } })],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }